import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fa5, faPen, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import AddStaffModal from "./AddStaffModal";
import { getAllStaff } from "../../CrudOperations/GetOperation";

const ManageStaff = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [Staff, setStaff] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredStaffList, setFilteredStaffList] = useState([]);
  const [StaffList, setStaffList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [currentStaffId, setCurrentStaffId] = useState(null);
  const [newStatus, setNewStatus] = useState("");
  const [edit, setEdit] = useState("");
  const [ZoomImage, setZoomImage] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredStaffList.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const totalPages = Math.ceil(filteredStaffList.length / itemsPerPage);

  useEffect(() => {
    const fetchStaffs = async () => {
      const response = await getAllStaff();
      if (response?.data?.Message === "Success") {
        setStaffList(response?.data?.Data);
        setFilteredStaffList(response?.data?.Data);
      }
    };
    fetchStaffs();
  }, []);

  const handleSearchInput = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filteredList = StaffList.filter(
      (p) =>
        p.FullName.toLowerCase().includes(query) ||
        p.ContactNo.toLowerCase().includes(query) ||
        p.Department.toLowerCase().includes(query) ||
        p.Designation.toLowerCase().includes(query) ||
        p.Address.toLowerCase().includes(query)
    );
    setFilteredStaffList(filteredList);
  };

  const handleAddStaff = async (e) => {
    e.preventDefault();
    if (Staff) {
      const response = await AddStaff({ Staff });
      if (response.data.message === "Staff saved successfully!") {
        const newStaff = { Staff, id: response.data.data.id };
        setStaffList([...StaffList, newStaff]);
        setFilteredStaffList([...filteredStaffList, newStaff]);
        setStaff("");
        toast.success("Staff added successfully!");
      } else {
        toast.error("Failed to add Staff. Please try again.");
      }
    } else {
      toast.error("Please enter a valid Staff.");
    }
  };

  const handleDeleteStaff = async (id) => {
    const previousStaffList = [...StaffList];
    const previousFilteredStaffList = [...filteredStaffList];

    const updatedList = StaffList.filter((p) => p.id !== id);
    setStaffList(updatedList);
    setFilteredStaffList(updatedList);

    try {
      const response = await DeleteStaff(id);
      if (response.data.message === "Staff deleted successfully") {
        toast.success("Staff deleted successfully");
      } else {
        setStaffList(previousStaffList);
        setFilteredStaffList(previousFilteredStaffList);
        toast.error("Failed to delete Staff. Please try again.");
      }
    } catch (error) {
      setStaffList(previousStaffList);
      setFilteredStaffList(previousFilteredStaffList);
      toast.error("Error deleting Staff.");
    }
  };

  // handleUpdateStaff

  const handleUpdateStaff = async (p) => {
    setEdit(p);

    setIsModalOpen(true);
  };

  const handleCheckboxChange = (id, isChecked) => {
    // Set the current Staff ID and the new status based on the checkbox state
    setCurrentStaffId(id);
    setNewStatus(isChecked ? "Available" : "Not Available");
    setIsConfirmModalOpen(true); // Open the confirmation modal
  };

  const confirmChangeStatus = async () => {
    if (currentStaffId !== null) {
      // Update status in StaffList
      setStaffList((prevList) =>
        prevList.map((item) =>
          item.id === currentStaffId ? { ...item, Status: newStatus } : item
        )
      );

      // Update status in filteredStaffList
      setFilteredStaffList((prevList) =>
        prevList.map((item) =>
          item.id === currentStaffId ? { ...item, Status: newStatus } : item
        )
      );

      try {
        const response = await UpdateStaffStatus({
          id: currentStaffId,
          Status: newStatus,
        });
        if (response.data.message === "Staff updated successfully!") {
          toast.success(`Status updated to ${newStatus} successfully!`);
        } else {
          toast.error("Error updating status.");
        }
      } catch (error) {
        toast.error("Error updating status.");
      } finally {
        setIsConfirmModalOpen(false); // Close the confirmation modal
        setCurrentStaffId(null); // Reset the ID
      }
    }
  };

  const handleAddStaffformClick = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setEdit("");
    setIsModalOpen(false);
  };

  const handleSubmit = async () => {
    const response = await getAllStaff();
    if (response.data.Message === "Success") {
      setStaffList(response.data.Data);
      setFilteredStaffList(response.data.Data);
    }

    setEdit("");
    setIsModalOpen(false); // Close the modal after adding
    toast.success("Staff added or Updated successfully!");
  };

  const handleUpdate = (newStaff) => {
    console.log("Updated Staff:", newStaff);
    console.log("Editing Staff ID:", edit.id);
    console.log("Staff List:", StaffList);

    setStaffList((prev) =>
      prev.map((prevStaff) =>
        prevStaff.id === edit.id
          ? {
              ...prevStaff, // Keep existing properties
              ...newStaff, // Merge properties from newStaff
            }
          : prevStaff
      )
    );

    setFilteredStaffList((prev) =>
      prev.map((prevStaff) =>
        prevStaff.id === edit.id
          ? {
              ...prevStaff,
              ...newStaff,
            }
          : prevStaff
      )
    );

    setEdit(null);
    closeModal(); // Close the modal after updating
  };

  const handleFilterChange = (e) => {
    const selectedStatus = e.target.value;

    if (!selectedStatus) {
      setFilteredStaffList(StaffList);
      return;
    }

    const filteredList = StaffList.filter(
      (item) => item.Status === selectedStatus
    );
    setFilteredStaffList(filteredList);
  };

  const handleZoomOut = (Image) => {
    setZoomImage(Image);
  };

  return (
    <div className="container mx-auto p-8 bg-white rounded-lg shadow-lg shadow-gray-300">
      <h1 className="text-xl font-inter font-bold mb-6 border-b-4 border-blue-600 pb-2 text-gray-800">
        Manage Deputy
      </h1>

      <div className="mb-6 flex justify-between items-center">
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearchInput}
          className="w-1/2 border border-gray-300 p-3 rounded-md transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
        />

        <div className="flex gap-4">
          <button
            className="w-16 h-16 text-sm rounded-full bg-gray-400 text-white font-bold p-2"
            onClick={() => {
              setFilteredStaffList(StaffList);
            }}
          >
            All
          </button>
          <button
            className="w-16 h-16 text-sm rounded-full bg-green-500 text-white font-bold "
            onClick={() => {
              const filteredList = StaffList.filter((p) => p.isAvailable === 1);
              setFilteredStaffList(filteredList);
            }}
          >
            Active
          </button>
          <button
            className="w-16 h-16 text-sm rounded-full bg-red-500 text-white font-bold p-1"
            onClick={() => {
              const filteredList = StaffList.filter((p) => p.isAvailable == 0);
              setFilteredStaffList(filteredList);
            }}
          >
            InActive
          </button>
        </div>
        {console.log(StaffList)}
        <div className="flex items-center gap-4">
          <button
            onClick={handleAddStaffformClick}
            className="bg-blue-600 text-white px-6 py-2 rounded-md flex items-center gap-2 transition-transform duration-200 hover:bg-blue-700 hover:scale-105 shadow-md shadow-blue-500 hover:shadow-lg"
          >
            <FontAwesomeIcon icon={faPlus} />
            Add Deputy
          </button>
        </div>
      </div>

      {/* Responsive table wrapper */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white table-auto border border-gray-300 rounded-lg shadow-sm">
          <thead className="bg-gray-100 ">
            <tr>
              {[
                "SNo",
                "Image",
                "Name",
                "Code",
                "Contact Number",
                            "Gender",
                "Department",
                "Designation",
                "Address",
                "Community",
                "Status",
                "Edit",
              ].map((heading) => (
                <th
                  key={heading}
                  className="py-3 px-4 text-center font-semibold text-gray-700"
                >
                  {heading}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {console.log(currentItems)}

            {currentItems.length > 0 ? (
              currentItems.map((p, index) => (
                <tr
                  key={p.StaffId}
                  className="border-b transition-colors duration-200 hover:bg-gray-50"
                >
                  <td className="py-3 px-4 text-center">
                    {" "}
                    {(currentPage - 1) * itemsPerPage + index + 1}
                  </td>
                  <td className="py-3 px-4 text-center">
                    {((
                      <img
                        onClick={() => {
                          handleZoomOut(p.StaffImage);
                        }}
                        src={

                          
                          p.StaffImage ? p.StaffImage 
                          : p.Gender == "Female"  
                          ? 
                          "https://up.yimg.com/ib/th?id=OIP.n7FlwCSlzWX0V3VxBeVLRwAAAA&pid=Api&rs=1&c=1&qlt=95&w=119&h=119" : 
                          "https://up.yimg.com/ib/th?id=OIP.w0TcjC4y9CxTrY3sitYa_AAAAA&pid=Api&rs=1&c=1&qlt=95&w=115&h=115"  
                        
                        
                        }
                        alt=""
                        className="cursor-pointer w-12 h-12"
                      />
                    )) }
                  </td>

                  <td className="py-3 px-4 text-center">{p.FullName}</td>

                  <td className="py-3 px-4 text-center">
                    {p.StaffCode ? p.StaffCode : "N/A"}
                  </td>

                  <td className="py-3 px-4 text-center">{p.ContactNo}</td>
                  <td className="py-3 px-4 text-center">{p.Gender}</td>

                  <td className="py-3 px-4 text-center">{p.Department}</td>
                  <td className="py-3 px-4 text-center">{p.Designation}</td>
                  <td className="py-3 px-4 text-center">{p.Address}</td>
                  <td className="py-3 px-4 text-center">
                    {p.CommunityName || "N/A"}
                  </td>

                  <td className="py-3 px-4 text-center">
                    {p.isAvailable === 0 ? "InActive" : "Active"}
                  </td>
                  <td className="py-3 px-4 text-center">
                    <button
                      onClick={() => handleUpdateStaff(p)}
                      className="text-blue-500 transition-colors duration-200 hover:text-blue-700"
                    >
                      <FontAwesomeIcon icon={faPen} />
                    </button>
                  </td>

                  {/* <td className="py-3 px-4 text-center">
                    <button
                      onClick={() => handleDeleteStaff(p.id)}
                      className="text-red-500 transition-colors duration-200 hover:text-red-700"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="py-3 text-center text-gray-600">
                  No Staffs found.
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="flex justify-center mt-4 gap-2">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded disabled:opacity-50"
          >
            Prev
          </button>

          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => setCurrentPage(i + 1)}
              className={`px-3 py-1 rounded ${
                currentPage === i + 1
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-700"
              }`}
            >
              {i + 1}
            </button>
          ))}

          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>

      {/* Zoom Image */}

      {ZoomImage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
          <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] flex flex-col">
            {/* Cancel Button */}
            <button
              onClick={() => setZoomImage(null)}
              className="absolute top-2 right-2 text-gray-600 hover:text-red-500 text-2xl font-bold"
            >
              &times;
            </button>

            <img
              src={ZoomImage}
              alt="ZoomImage"
              className="object-contain max-h-[85vh]"
            />
          </div>
        </div>
      )}

      {/* Add Staff Modal */}
      {isModalOpen && (
        <AddStaffModal
          closeModal={closeModal}
          onSubmit={handleSubmit}
          Staff={edit}
          onUpdate={handleUpdate}
        />
      )}
    </div>
  );
};

export default ManageStaff;
